import appActionKeys from './appActionKeys';

type BusinessCenterPhone = {
  tel: string,
  text: string,
};

export function setBusinessCenterPhone(businessCenterPhone: BusinessCenterPhone = {}) {
  return {
    type: appActionKeys.SET_BUSINESS_CENTER_PHONE,
    payload: businessCenterPhone,
  };
}

export default {
  setBusinessCenterPhone,
};



// WEBPACK FOOTER //
// ./src/app/common/appActions.js